var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.58363L9.16667 11.2503L12.9167 7.5003M16.6667 10.0003C16.6667 14.0907 12.205 17.0656 10.5817 18.0127C10.3972 18.1203 10.3049 18.1741 10.1747 18.2021C10.0737 18.2237 9.9263 18.2237 9.82527 18.2021C9.69508 18.1741 9.60283 18.1203 9.41834 18.0127C7.79497 17.0656 3.33333 14.0907 3.33333 10.0003V6.01497C3.33333 5.34871 3.33333 5.01558 3.4423 4.72922C3.53856 4.47625 3.69499 4.25053 3.89805 4.07157C4.12791 3.869 4.43983 3.75203 5.06367 3.51809L9.53184 1.84253C9.70508 1.77756 9.79171 1.74508 9.88082 1.7322C9.95986 1.72078 10.0401 1.72078 10.1192 1.7322C10.2083 1.74508 10.2949 1.77756 10.4682 1.84253L14.9363 3.51809C15.5602 3.75203 15.8721 3.869 16.102 4.07157C16.305 4.25053 16.4614 4.47625 16.5577 4.72922C16.6667 5.01558 16.6667 5.34871 16.6667 6.01497V10.0003Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.740fbcd3ba620c76a549f186c15742de.svg";
export { ForwardRef as ReactComponent };